import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { redoTreeEdits } from 'store/slices/TreeSlice';
import CustomRedoBtn from 'components/tool/Editor/ButtonDiv/RedoButton';

export default function TreeRedoButton({ disabled: externalDisabled }: { disabled?: boolean }) {
	const dispatch = useDispatch();
	const { history, currentIndex } = useSelector((state: RootState) => state.treeSlice.data);

	const disabled = currentIndex >= history.length - 1 || !!externalDisabled;
	const show = history.length > 1;

	if (!show) return null;

	return (
		<CustomRedoBtn
			id="redo"
			disabled={disabled}
			onClick={() => dispatch(redoTreeEdits())}
		/>
	);
}
